import api from "@/core/services/api.service";

const photoService = {
    
    get(params) {
        api.setHeader()
        return api.post("api/photos", params)
    },

}

export default photoService